import {
  COMPONENT_VALUE_TYPES as types,
  BACKGROUND_PICKER_CONTENT_TYPE,
  FLEXIBLE_COLUMNS_COUNT,
  FLEXIBLE_COLUMNS_VARIANTS,
  BACKGROUND_IMAGE_POSITION,
  FLEXIBLE_COLUMNS_DIRECTION,
  FLEX_JUSTIFY_CONTENT_POSITION,
  ALIGN_ITEMS,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'section_tag',
    label: 'Section Tag (Used with Vertical Nav Bar)',
    type: types.TEXT
  },
  {
    key: 'padding_all',
    label: 'Padding',
    type: types.OBJECT,
    children: [
      {
        key: 'menu_bar_padding',
        label: 'Add Top Padding for Menu Bar (Overrides Container Top Padding)',
        type: types.BOOLEAN
      },
      {
        key: 'use_mobile_padding',
        label: 'Adaptive on mobile',
        type: types.BOOLEAN
      },
      {
        key: 'padding_container_top',
        label: 'Container Top Padding',
        type: types.TEXT
      },
      {
        key: 'padding_container_bottom',
        label: 'Container Bottom Padding',
        type: types.TEXT
      },
      {
        key: 'horizontal_outer_padding',
        label: 'Container Left/Right Padding',
        type: types.TEXT
      },
      {
        key: 'horizontal_inner_padding',
        label: 'Inner Column Left/Right Padding',
        type: types.TEXT
      },
      {
        key: 'vertical_inner_padding',
        label: 'Inner Row Top/Bottom Padding',
        type: types.TEXT
      },
      {
        key: 'padding_all_tablet',
        label: 'Padding Tablet',
        type: types.OBJECT,
        children: [
          {
            key: 'padding_container_top_tablet',
            label: 'Container Top Padding',
            type: types.TEXT
          },
          {
            key: 'padding_container_bottom_tablet',
            label: 'Container Bottom Padding',
            type: types.TEXT
          },
          {
            key: 'horizontal_outer_padding_tablet',
            label: 'Container Left/Right Padding',
            type: types.TEXT
          },
          {
            key: 'horizontal_inner_padding_tablet',
            label: 'Inner Column Left/Right Padding',
            type: types.TEXT
          },
          {
            key: 'vertical_inner_padding_tablet',
            label: 'Inner Row Top/Bottom Padding',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'padding_all_mobile',
        label: 'Padding Mobile',
        type: types.OBJECT,
        children: [
          {
            key: 'padding_container_top_mobile',
            label: 'Container Top Padding',
            type: types.TEXT
          },
          {
            key: 'padding_container_bottom_mobile',
            label: 'Container Bottom Padding',
            type: types.TEXT
          },
          {
            key: 'horizontal_outer_padding_mobile',
            label: 'Container Left/Right Padding',
            type: types.TEXT
          },
          {
            key: 'horizontal_inner_padding_mobile',
            label: 'Inner Column Left/Right Padding',
            type: types.TEXT
          },
          {
            key: 'vertical_inner_padding_mobile',
            label: 'Inner Row Top/Bottom Padding',
            type: types.TEXT
          }
        ]
      }
    ]
  },
  {
    key: 'height_all',
    label: 'Height Controls',
    type: types.OBJECT,
    children: [
      {
        key: 'height_percentage',
        label: 'Target Height (ex: 50% or 50)',
        type: types.TEXT
      },
      {
        key: 'height_minimum',
        label: 'Minimum Height (ex: 500px or 500)',
        type: types.TEXT
      },
      {
        key: 'height_maximum',
        label: 'Maximum Height (ex: 500px or 500)',
        type: types.TEXT
      },
      {
        key: 'height_all_tablet',
        label: 'Height Tablet',
        type: types.OBJECT,
        children: [
          {
            key: 'height_percentage_tablet',
            label: 'Target Height (ex: 50% or 50)',
            type: types.TEXT
          },
          {
            key: 'height_minimum_tablet',
            label: 'Minimum Height (ex: 500px or 500)',
            type: types.TEXT
          },
          {
            key: 'height_maximum_tablet',
            label: 'Maximum Height (ex: 500px or 500)',
            type: types.TEXT
          }
        ]
      },
      {
        key: 'height_all_mobile',
        label: 'Height Mobile',
        type: types.OBJECT,
        children: [
          {
            key: 'height_percentage_mobile',
            label: 'Target Height (ex: 50% or 50)',
            type: types.TEXT
          },
          {
            key: 'height_minimum_mobile',
            label: 'Minimum Height (ex: 500px or 500)',
            type: types.TEXT
          },
          {
            key: 'height_maximum_mobile',
            label: 'Maximum Height (ex: 500px or 500)',
            type: types.TEXT
          }
        ]
      }
    ]
  },
  {
    key: 'width_controls',
    label: 'Width Controls',
    type: types.OBJECT,
    children: [
      {
        key: 'max_width',
        label: 'Set the width to 100%',
        type: types.BOOLEAN
      },
    ]
  },
  {
    key: 'background',
    label: 'Background',
    type: types.BACKGROUND_PICKER,
    children: [
      {
        key: 'use_background_color',
        label: 'Use Background Color',
        type: types.COLOR_PICKER
      },
      {
        key: 'color',
        label: 'Color',
        type: types.COLOR_PICKER
      },
      {
        key: 'content_type',
        label: 'Content Type',
        type: types.ENUM,
        options: BACKGROUND_PICKER_CONTENT_TYPE
      },
      {
        key: 'content',
        label: 'URL',
        type: types.S3_ASSET_URL
      },
      {
        key: 'tablet_content',
        label: 'Tablet Image Content URL',
        type: types.S3_ASSET_URL
      },
      {
        key: 'position',
        label: 'Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      },
      {
        key: 'background_to_image_mobile',
        label: 'Show background as standalone image on mobile',
        type: types.BOOLEAN
      },
      {
        key: 'mobile_content',
        label: 'Mobile URL',
        type: types.S3_ASSET_URL
      },
    ]
  },
  {
    key: 'column_layout',
    label: 'Column Layout',
    type: types.FLEXIBLE_COLUMN_LAYOUT,
    children: [
      {
        key: 'mobile_keep_direction',
        label: 'Retain same direction in mobile layout (don\'t convert to column)',
        type: types.BOOLEAN
      },
      {
        key: 'direction',
        label: 'Layout Direction',
        type: types.ENUM,
        options: FLEXIBLE_COLUMNS_DIRECTION
      },
      {
        key: 'remove_column_space',
        label: 'Remove space between columns (Enables Layout Position)',
        type: types.BOOLEAN
      },
      {
        key: 'position_column',
        label: 'Layout Position (Column)',
        type: types.ENUM,
        options: ALIGN_ITEMS,
      },
      {
        key: 'position_row',
        label: 'Layout Position (Row)',
        type: types.ENUM,
        options: FLEX_JUSTIFY_CONTENT_POSITION,
      },
      {
        key: 'count',
        label: 'Number of Columns',
        type: types.ENUM,
        options: FLEXIBLE_COLUMNS_COUNT
      },
      {
        key: 'variant',
        label: 'Layout Variant',
        type: types.ENUM,
        options: FLEXIBLE_COLUMNS_VARIANTS
      },
      {
        key: 'remove_z_index',
        label: 'Check it to remove the default value(3) of zIndex of column container.',
        type: types.BOOLEAN
      },
      {
        key: 'fillSpace',
        label: 'Grow one cell to fill all space',
        tooltip: 'Increase the size of a specified cell to fill up the configured height or width of the Flexible Columns widget.',
        type: types.BOOLEAN
      },
      {
        key: 'fillSpaceIndex',
        label: 'Grown cell index',
        tooltip: 'Index of the cell which will grow to fill available space.',
        type: types.ENUM,
        options: FLEXIBLE_COLUMNS_COUNT
      },
    ]
  },
  {
    key: 'hidden_controls',
    label: 'Hidden Controls',
    type: types.OBJECT,
    children: [
      {
        key: 'hide_on_desktop',
        label: 'Hide On Desktop',
        type: types.BOOLEAN
      },
      {
        key: 'hide_on_tablet',
        label: 'Hide On Tablet',
        type: types.BOOLEAN
      },
      {
        key: 'hide_on_mobile',
        label: 'Hide On Mobile',
        type: types.BOOLEAN
      },
    ]
  },
  {
    key: 'scrollSnapAlign',
    label: 'Scroll Snap Align (for home page animation)',
    type: types.ENUM,
    options: ['none', 'start']
  },
];

const defaultProps = {
  section_tag: '',
  padding_all: {
    menu_bar_padding: false,
    use_mobile_padding: false,
    padding_container_top: '0px',
    padding_container_bottom: '0px',
    horizontal_outer_padding: '0px',
    horizontal_inner_padding: '0px',
    vertical_inner_padding: '0px'
  },
  height_all: {
    height_percentage: '',
    height_minimum: '',
    height_maximum: '',
  },
  width_controls: {
    max_width: false
  },
  background: {
    use_background_color: false,
    color: '#cfd3d6',
    content_type: 'None',
    content: '',
    position: 'CENTER CENTER',
    background_to_image_mobile: false
  },
  column_layout: {
    mobile_keep_direction: false,
    remove_column_space: false,
    direction: 'Single Row',
    count: '2',
    variant: '1:1',
    position_column: 'stretch',
    position_row: 'flex-start'
  },
  hidden_controls: {
    hide_on_desktop: false,
    hide_on_tablet: false,
    hide_on_mobile: false
  }
};

export default {
  title: 'Flexible Columns',
  id: 'FlexibleColumns',
  widgetImage: '/widgetImages/Column.png',
  basic: true,
  propsSchema,
  defaultProps
};
